
<script>
  import { setContext } from 'svelte';
  import Events from '~/events';
  import View from 'components/View.svelte';
  import { playerOn } from './stores';

  // Make app available for descendants
  export let app;
  setContext('app', app);
  const devMode = app.key('devMode');

  // User activity is followed for session and screensaver timer reset
  function userActivity (event) {
    if ($playerOn) {
      devMode && console.time('player off');
      event.preventDefault(); // block instant navigation
      $playerOn = false; // close player as fast as possible
    }
    Events.dispatchEvent('user:activity');
  }

</script>

<svelte:window
  on:click|nonpassive={userActivity}
  on:touchstart|nonpassive={userActivity}
  on:touchmove|nonpassive={userActivity}
  on:mousewheel|nonpassive={userActivity}
  on:wheel|nonpassive={userActivity} />

<View />
